import { connect } from 'react-redux'
import React from 'react'
import Stats from '../components/Stats'
import { toggleStats } from '../actions'
import { isDblTouchTap } from 'aria-viewer/utils/uiEvents'
import compose from 'recompose/compose'

const mapStateToProps = state => ({
    isEnabled: state.getIn(['stats', 'enableStats']),
})

const mapDispatchToProps = dispatch => ({
    onTouchStart: e => {
        if (isDblTouchTap(e)) dispatch(toggleStats())
    },
})

const renderHOC = WrappedComponent => ({ isEnabled, ...props }) => (isEnabled ? <WrappedComponent {...props} /> : null)

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    renderHOC
)(Stats)
